import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getStoredLang, setStoredLang, t as translate, pick as pickHelper } from "./i18n";

const LangContext = createContext({ lang: "fr", setLang: () => {}, t: (k) => k, pick: () => "" });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(getStoredLang());

  const setLang = (l) => {
    setLangState(l);
    setStoredLang(l);
    try { document.documentElement.setAttribute("lang", l); } catch (_) { /* ignore */ }
  };

  useEffect(() => {
    try { document.documentElement.setAttribute("lang", lang); } catch (_) { /* ignore */ }
  }, [lang]);

  const value = useMemo(() => ({
    lang,
    setLang,
    t: (k, params) => translate(k, lang, params),
    pick: (o) => pickHelper(o, lang),
  }), [lang]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
